import cn from "classnames";
import React from "react";
import ClaimAnalyticSvg from "../../../components/svgComponents/ClaimAnalyticSvg";
import { MIN_CLAIM_NODE_AMOUNT } from "../constants";
import { Loader } from '../../../components/Loader';

const ClaimAnalytic = ({
  handleClaimXbrRewards,
  selectedNode,
  xbrPrice,
  isVerifying,
}) => {
  const totalClaimedUsdt = () => {
    return selectedNode.reward === 0
      ? 0
      : (selectedNode.reward * xbrPrice).toFixed(2);
  };
  return (
    <article className="bg-white rounded-3xl p-6 dark:bg-darkCardBg">
      <div className="mb-5 flex items-center gap-[10px]">
        <div className="w-[38px] h-[38px] flex justify-center items-center bg-iceBlue rounded-lg dark:bg-[#1D1C2D] dark:border dark:border-deepBlue">
          <ClaimAnalyticSvg />
        </div>
        <div>
          <h4 className="text-xs leading-[14px] text-semiBlack dark:text-semiWhite">
            Node Rewards
          </h4>
          <p className="font-semibold leading-6 text-xl text-black dark:text-white">
            Claim
          </p>
        </div>
      </div>
      <div className="mb-5">
        <p className="mb-2 text-semiBlack dark:text-semiWhite text-xs leading-[14px] h-[28px] custom1402:h-fit tracking-[0.015em]">
          Total Rewards to Claim
        </p>
        <div>
          <p className="font-semibold leading-6 text-xl text-deepBlue">
            {selectedNode
              ? Number(selectedNode.reward).toFixed(5)
              : "00.00 XBR"}
          </p>
          <p className="text-semiBlack dark:text-semiWhite text-sm leading-6">{`≈ ${
            selectedNode ? totalClaimedUsdt() : "00.00"
          }$`}</p>
        </div>
      </div>
      <button
        onClick={() => {
          handleClaimXbrRewards(selectedNode);
        }}
        disabled={!selectedNode || isVerifying || Number(selectedNode.reward) < MIN_CLAIM_NODE_AMOUNT}
        type="button"
        className={cn(
          "bg-iceBlue w-full rounded-lg py-3 font-semibold dark:bg-darkCardBg min-h-[47px] dark:border dark:border-white text-sm leading-[21px] flex justify-center items-center gap-2 text-lightBlack dark:text-semiWhite",
          {
            "!bg-deepBlue border border-white !text-white shadow-swapButton transition-all duration-300 hover:!bg-vividBlueViolet active:translate-x-[1px] active:translate-y-[1px] ":
              selectedNode && (Number(selectedNode.reward) >= MIN_CLAIM_NODE_AMOUNT),
            "!opacity-50": isVerifying,
          }
        )}
      >
        
        {isVerifying 
          ? <Loader fill="#fff" ratio={20} /> 
          : <>
            <ClaimAnalyticSvg selectedNode={selectedNode} isButtonIcon={true} />
            Claim
          </>}
      </button>
    </article>
  );
};

export default ClaimAnalytic;
